import React from 'react'

export default function Field({
  name,
  label,
  placeholder,
  onChange,
  required,
  register,
  error,
}) {
  return (
    <div className="flex flex-col w-full">
      <p className="m-2 text-sm font-semibold">{label}</p>
      <input
        {...register}
        onChange={onChange}
        type="text"
        placeholder={placeholder}
        name={name}
        required={required}
        className="w-full px-3 py-3 mr-4 border seacrh rounded-2xl focus:ring-2 focus:ring-primary focus:border-none focus:outline-none"
      />
      {error && (
        <p className="text-sm font-thin text-red-600">{error.message}</p>
      )}
    </div>
  );
}
